import React, { useRef, useEffect } from 'react';
import MessageBubble from './MessageBubble';

function MessageList({ messages, currentUserId, loading, onLoadMore, hasMore, onEditMessage, onDeleteMessage }) {
  const bottomRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages?.length]);

  if (loading && !messages?.length) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!messages?.length) {
    return (
      <div className="text-center py-8 text-gray-500 text-sm">
        No messages yet. Send a message to start the conversation.
      </div>
    );
  }

  return (
    <div ref={containerRef} className="flex flex-col flex-1 overflow-y-auto p-4">
      {hasMore && (
        <div className="flex justify-center py-2">
          <button
            type="button"
            onClick={onLoadMore}
            className="text-sm text-blue-600 hover:underline"
          >
            Load older messages
          </button>
        </div>
      )}
      {messages.map((msg) => (
        <MessageBubble
          key={msg.id}
          message={msg}
          isOwn={msg.sender?.id === currentUserId}
          showSenderName={true}
          onEdit={onEditMessage}
          onDelete={onDeleteMessage}
        />
      ))}
      <div ref={bottomRef} />
    </div>
  );
}

export default MessageList;
